import * as React from 'react';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { zIndexLayer } from '../../../constants/enum';

type CircularProgressProps = React.ComponentProps<typeof CircularProgress>;

type Props = CircularProgressProps & {
  loading: boolean;
};

export default function CustomLoading(props: Props): JSX.Element {
  const { loading, ...rest } = props;
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: zIndexLayer.loading,
        // 非表示のときはクリックを一切受け取らない（#3259）。
        // Backdrop はフェードアウトのトランジション完了時に visibility: hidden へ切り替わるが、
        // 環境によっては完了せず visibility: visible のまま残ることがある。
        // その場合、透明（opacity: 0）で見えないまま画面全体を覆い続け、
        // ボタン・入力欄・サイドバーのすべてがクリックに反応しなくなる。
        pointerEvents: loading ? 'auto' : 'none',
      }}
      open={loading}
    >
      <CircularProgress
        sx={{
          color: 'white',
        }}
        {...rest}
      />
    </Backdrop>
  );
}
